import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, LightbulbIcon } from 'lucide-react';
interface HelpPanelProps {
  question: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function HelpPanel({
  question,
  children,
  defaultOpen = false
}: HelpPanelProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="rounded-2xl bg-ink-100/70" data-id="element-680" data-mp="kpf3dzu0gon1">
      <button type="button" aria-expanded={open} onClick={() => setOpen(o => !o)} className="flex w-full items-center gap-3 rounded-2xl px-4 py-3.5 text-left text-sm font-medium text-ink-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500" data-id="element-681" data-mp="kq870rxoay0y">
        <LightbulbIcon className="h-4 w-4 shrink-0 text-pulse-600" aria-hidden data-id="element-682" data-mp="otecvygvin6w" />
        <span className="flex-1" data-id="element-683" data-mp="253yuzyunupp1">{question}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-400 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden data-id="element-684" data-mp="206p5ykb6og1q" />
      </button>
      <AnimatePresence initial={false} data-id="element-685" data-mp="j7rf1e5z08jk">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-686" data-mp="j680pt3vk7kf">
            <div className="px-4 pb-4 pl-11 text-sm leading-relaxed text-ink-500" data-id="element-687" data-mp="3rpfkdiep1w9z">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}